import React, { useState, useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { BRAND_DISPLAY_NAME, DEEP_LINKS_APP_TO_WEB } from 'app-constants'
import { Button } from 'components'
import { STATICS } from 'statics'
import { PLATFORM_OPERATION_SYSTEM } from './constants'
import './style.scss'

export function AppMobileRedirect() {
  const [platform, setPlatform] = useState(null)
  const { push } = useHistory()

  const currentPath = window.location.pathname
  const deepPath = currentPath.replace(/^\/app\/?/, '')

  const schemeBase = 'gigamaisfibra://'
  const fullDeepLink = `${schemeBase}${deepPath}`
  const androidIntent = `intent://${deepPath}#Intent;scheme=gigamaisfibra;package=br.net.sumicity.central;S.browser_fallback_url=https://play.google.com/store/apps/details?id=br.net.sumicity.central;end`

  const handleBrowserRedirect = useCallback(() => {
    const redirectQuery = DEEP_LINKS_APP_TO_WEB[deepPath]
    push(`/?${redirectQuery || ''}`)
  }, [deepPath, push])

  const getUserAgent = useCallback(() => {
    const ua = navigator.userAgent.toLowerCase()
    const isAndroid = ua.includes('android')
    const isIOS = /ipad|iphone|ipod/.test(ua) && !window.MSStream

    return { isAndroid, isIOS }
  }, [])

  useEffect(() => {
    const { isAndroid, isIOS } = getUserAgent()

    if (isAndroid) setPlatform(PLATFORM_OPERATION_SYSTEM.ANDROID)
    else if (isIOS) setPlatform(PLATFORM_OPERATION_SYSTEM.IOS)
  }, [getUserAgent])

  useEffect(() => {
    const { isAndroid, isIOS } = getUserAgent()

    const isMobile = isAndroid || isIOS

    if (isMobile) return

    handleBrowserRedirect()
  }, [getUserAgent, handleBrowserRedirect, platform])

  function handleCloseBanner() {
    setPlatform(null)
  }

  function handleIosClick(e) {
    e.preventDefault()
    window.location.href = fullDeepLink

    setTimeout(() => {
      if (document.visibilityState === 'visible') {
        window.location.href = 'https://apps.apple.com/br/app/id1234351006'
      }
    }, 2000)
  }

  function renderIosButton() {
    return (
      <button className='action-btn' type='button' onClick={handleIosClick}>
        ABRIR
      </button>
    )
  }

  function renderAndroidButton() {
    return (
      <a className='action-btn' href={androidIntent}>
        ABRIR
      </a>
    )
  }

  function renderMobileRedirect() {
    if (!platform) return null

    const isIos = platform === 'ios'
    return (
      <div className='smart-banner'>
        <button className='close-btn' onClick={handleCloseBanner} type='button'>
          ×
        </button>
        <img className='app-icon' src={STATICS.LOGO_HEADER} alt={`${BRAND_DISPLAY_NAME} logo`} />
        <div className='content'>
          <p className='title'>Acesse o app Giga+</p>
          <p className='text'>você será redirecionado</p>
        </div>
        {isIos ? renderIosButton() : renderAndroidButton()}
      </div>
    )
  }

  function renderWebAccess() {
    return (
      <Button
        onClick={handleBrowserRedirect}
        color='primary'
        size='large'
        className='internal-redirect'
      >
        Acessar pelo navegador
      </Button>
    )
  }

  return (
    <div className='app-mobile-redirect-page'>
      {renderMobileRedirect()}
      {renderWebAccess()}
    </div>
  )
}
